
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_134_1_SidebarColors";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_134_1_SidebarColors__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"sidebarBackgroundColor":"#23263c","textColor":"var(--wsr-color-D80, #FFFFFF)","hoveredBackgroundColor":"#2e3149","selectedBackgroundColor":"#3b3f57","selectedTextColor":"var(--wsr-color-B10, #3899EC)","disabledBackgroundColor":"#23263c","dividerColor":"#434567","darkScrollbarThumbColor":"var(--wsr-color-D80-42, rgba(255, 255, 255, 0.42))","darkScrollbarThumbHoverColor":"var(--wsr-color-D80-66, rgba(255, 255, 255, 0.66))","sidebarLightBackgroundColor":"var(--wsr-color-D80, #FFFFFF)","lightTextColor":"var(--wsr-color-D20, #32536A)","hoveredLightBackgroundColor":"var(--wsr-color-B50, #EAF7FF)","selectedLightBackgroundColor":"var(--wsr-color-B40, #DAEFFE)","selectedLightTextColor":"var(--wsr-color-B00, #2B81CB)","disabledLightBackgroundColor":"var(--wsr-color-D80, #FFFFFF)","lightScrollbarThumbColor":"var(--wsr-color-D10-42, rgba(22, 45, 61, 0.42))","lightScrollbarThumbHoverColor":"var(--wsr-color-D10-66, rgba(22, 45, 61, 0.66))"}; 
export var vars = {}; 




